import * as store from '@attain-apps/fe/web/main/lib/store'

import * as ecModels from '../../../models'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends ecModels.TypeParams.Constraint,
>() {
  return {
    applyEdits: store.actions.request({
      input: ({
        target = ecModels.Target.DEFAULT,
      }: {
        readonly target?: ecModels.Target
      } = {}) => ({ target }),
      output: store.actions.Data.NONE,
      reducersDeprecated: {
        request: (state: State<TTypeParams>, { target }) => ({
          ...state,
          editedTargets: new Set(
            [...state.editedTargets].filter(t => t !== target),
          ),
        }),
      },
    }),
    discardEdits: store.actions.request({
      input: ({
        target = ecModels.Target.DEFAULT,
      }: {
        readonly target?: ecModels.Target
      } = {}) => ({ target }),
      output: store.actions.Data.NONE,
      reducersDeprecated: {
        request: (state: State<TTypeParams>, { target }) => ({
          ...state,
          editedTargets: new Set(
            [...state.editedTargets].filter(t => t !== target),
          ),
        }),
      },
    }),
    getEntities: store.actions.request({
      input: ({
        target = ecModels.Target.DEFAULT,
        from,
        portion = 'all',
      }: {
        readonly target?: ecModels.Target
        readonly portion?: 'all' | 'first'
        /**
         * Leave `undefined` to automatically determine `edited` vs `applied`
         * depending on if the target is currently being edited
         */
        readonly from?: 'edited' | 'applied'
      }) => ({
        from,
        portion,
        target,
      }),
      output: store.actions.Data.asIs<{
        readonly entities: readonly TTypeParams['entity'][]
      }>(),
    }),
    startEditing: store.actions.standalone({
      data: ({
        target = ecModels.Target.DEFAULT,
        initialSelection = [],
      }: {
        readonly target?: ecModels.Target
        readonly initialSelection?: readonly ecModels.EntityId[]
      } = {}) => ({ initialSelection, target }),
      reducerDeprecated: (state: State<TTypeParams>, { target }) => ({
        ...state,
        editedTargets: new Set([...state.editedTargets, target]),
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State<TTypeParams>>
}
